import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Modules } from './appCommon/Enums/enum';
import { ErrorPageComponent } from './appWeb/pages/static-pages/components/error-page/error-page.component';
import { caseInsensitiveMatcher } from './appCommon/Pipes/LowerCaseUrlSerializer';
const routes: Routes = [

  { path: '', loadChildren: () => import('./appWeb/login-register/login-register.module').then(m => m.LoginRegisterModule) },
  { matcher:caseInsensitiveMatcher(Modules.Dashboard), loadChildren: () => import('./appWeb/dashboard/dashboard.module').then(d => d.DashboardModule) },
  { matcher:caseInsensitiveMatcher(Modules.Layout), loadChildren: () => import('src/app/appWeb/layout/layout.module').then(l => l.LayoutModule) },
  { path :'**',component: ErrorPageComponent}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
